module.exports = "/static/media/fax-papers.fbb98aa4.svg";